export enum MetadataKeys {
  Recipient = 'recipient',
  Expiration = 'expiration',
}

export interface IAssetAccessMetadata {
  label: string;
  value: string;
}

export interface IAssetAccessLog {
  _id: string;
  userId: number;
  userName: string;
  orgId: number;
  orgName: string;
  actionDate: Date;
  assetId: string;
  assetName: string;
  actionType: string;
  metadata: Array<IAssetAccessMetadata>;
  __v: number,
}

export interface IAssetAccessLogPayload {
  assetId: string;
  assetName: string;
  actionType: string;
  metadata?: Array<IAssetAccessMetadata>;
}
